import React from 'react';
import { connect } from 'react-redux';
import HospitalesForm from './hospitales.frm';

const mapDispatch = (dispatch) => {
    return {
    	guardarDatos(oData) {
            dispatch({ "type" : "DIRECTORIO_HOSPITALES_FORM", "hospitales": oData });
        },
        pasoSiguiente(_paso) {
            dispatch({ "type" : "DIRECTORIO_PASO_SIGUIENTE"});
        },
        tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
    }
}

class Hospitales extends React.Component {
	submit = (data) => {
		$("#contCMS .map-movil").show();
		this.props.tagManager({ "type": "EVENT_DIRECTORIOS_HOSPITALES-BUSCAR" });
	    return new Promise(resolve => {
	    	this.props.guardarDatos(data);
	        this.props.pasoSiguiente();
    		resolve();
	    });
	}

	render() {
		return <HospitalesForm onSubmit={this.submit} />;
	}
}

export default connect(null, mapDispatch)(Hospitales);


// WEBPACK FOOTER //
// ./src/directorio/hospitales.cmpt.js